import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Layout from "../components/common/Layout";
import authApi from "./../features/auth/api";
import { useSelector } from "react-redux";
import { SUPER_ADMIN } from "../constant";

const ProtectedRoute = () => {
  if (!localStorage.getItem("ACCESS_TOKEN")) {
    return <Navigate to="/" replace />;
  }

  return (
    <Layout>
      {" "}
      <Outlet />
    </Layout>
  );
};

export default ProtectedRoute;

const SuperProtectedRoute = ({children}) => {
  const userRole = useSelector((state) => state.auth?.userRole);
  const token = localStorage.getItem("ACCESS_TOKEN");
  if (!token) return <Navigate to="/" replace />;
  if (!userRole) return null;
  if (userRole?.RoleCode == SUPER_ADMIN) {
    return (
      <>
        {children}
        <Outlet />
      </>
    );
  }
  else
  return <Navigate to="/" replace />;
};

export { SuperProtectedRoute };
